import { all, fork } from 'redux-saga/effects'
import log from './log'

export default function* induction() {
  yield all([fork(log)])
}
